import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AppStore } from '@src/app-store';
import { AppArScene } from '@src/components/app-ar-scene/app-ar-scene';
import { AppFooter } from '@src/components/app-footer/app-footer';
import { AppGame } from '@src/components/app-game/app-game';
import { AppHeader } from '@src/components/app-header/app-header';
import { AppRules } from '@src/components/app-rules/app-rules';

@Component({
  imports: [AppHeader, AppFooter, AppGame, AppRules, AppArScene],
  providers: [AppStore],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  store = inject(AppStore);
}
